import { __decorate } from "tslib";
import { ArrayDecoder, field } from '@simonbackx/simple-encoding';
import { User } from '../User';
import { Member } from './Member';
import { Registration } from './Registration';
export class EncryptedMemberWithRegistrations extends Member {
}
__decorate([
    field({ decoder: new ArrayDecoder(Registration) })
], EncryptedMemberWithRegistrations.prototype, "registrations", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(User), version: 32 })
], EncryptedMemberWithRegistrations.prototype, "users", void 0);
//# sourceMappingURL=EncryptedMemberWithRegistrations.js.map